export default {
  name: 'app_categories',

  translatedAttributes: [
    'name',
    'description',
  ],

  /**
   * Prepare item data for backend request
   * @param item
   * @returns Object
   */
  toArray: item => ({
    ...item,
  }),

  /**
   * Parse backend payload to item object
   * @param data
   * @param initialItemData
   * @returns Object
   */
  fromArray: (data, initialItemData = {}) => ({
    ...data,
    ...initialItemData,
  }),

  resolveValidationErrors: errors => ({
    ...errors,
  }),
}
